export const sportsImagesAssetsUrl: string = 'https://static-assets.letsbetmd.com/images/';
